import { values as _values, orderBy as _orderBy } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const getUserState = (state: RootState) => state.user;

export const getUser = createSelector(getUserState, (state) => state.user);
export const getUserIsInitialized = createSelector(getUserState, (state) => state.isInitialized);
export const getUserIsLoading = createSelector(getUserState, (state) => state.isLoading);
